import { render, staticRenderFns } from "./ElLottie.vue?vue&type=template&id=77879451"
import script from "./ElLottie.vue?vue&type=script&lang=js"
export * from "./ElLottie.vue?vue&type=script&lang=js"
import style0 from "./ElLottie.vue?vue&type=style&index=0&id=77879451&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports